let React = require("react");

let ApplicationContext =  require("../../../config/ApplicationContext.js");

let WrappedModalHub =            require("./WrappedModalHub.jsx");

class SubscribeModalHub extends React.Component {

    newTap(){
        window.open(`https://www.autodesk.com/products/fusion-360/overview`, '_blank');
    }

    render() {
        return  <WrappedModalHub show={this.props.show} style="fifty" title={`${fullHubAlias} Limit`}
                    btnBlue={{show: true, text: "Subscribe", onClick: this.newTap}}
                    onClose={() => this.props.onClose("subscribe")}>
                        <img src={`${ApplicationContext.assetUrlPrefix}/assets/hub/img_example.png`}/>
                        <div className="clear"></div>
                          <p> Creating {fullHubAlias}s requires a paid Fusion subscription.

                          {' '+fullHubAlias}s allow you to share specific libraries, packages, and models with different teams.
                        </p>
                        <p className="bold">
                          Premium users may create up to 16 {fullHubAlias}s.
                        </p>

                </WrappedModalHub>

    }
}

module.exports = SubscribeModalHub;
